"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LauncherCheckInstalledGamesCompleteDTO = exports.LauncherCheckInstalledGamesStartDTO = exports.LauncherSetVersionDTO = exports.LauncherUpdateCompleteDTO = exports.LauncherUpdateStartDTO = exports.LauncherDownloadStartDTO = exports.LauncherConnectionCloseDTO = exports.LauncherConnectionCompleteDTO = exports.LauncherConnectionStartDTO = exports.LauncherAgreementAcceptDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
let LauncherAgreementAcceptDTO = class LauncherAgreementAcceptDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LauncherAgreementAcceptDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "currentVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "acceptedDocuments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Launcher version'),
    __metadata("design:type", String)
], LauncherAgreementAcceptDTO.prototype, "currentVersion", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('List of accepted documents'),
    __metadata("design:type", Array)
], LauncherAgreementAcceptDTO.prototype, "acceptedDocuments", void 0);
LauncherAgreementAcceptDTO = __decorate([
    (0, decorators_1.Describe)('Legal agreement for launcher was accepted by user')
], LauncherAgreementAcceptDTO);
exports.LauncherAgreementAcceptDTO = LauncherAgreementAcceptDTO;
let LauncherConnectionStartDTO = class LauncherConnectionStartDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LauncherConnectionStartDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "currentVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastConnected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Launcher version'),
    __metadata("design:type", String)
], LauncherConnectionStartDTO.prototype, "currentVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Last time launcher connected to user'),
    __metadata("design:type", String)
], LauncherConnectionStartDTO.prototype, "lastConnected", void 0);
LauncherConnectionStartDTO = __decorate([
    (0, decorators_1.Describe)('Launcher is connecting')
], LauncherConnectionStartDTO);
exports.LauncherConnectionStartDTO = LauncherConnectionStartDTO;
let LauncherConnectionCompleteDTO = class LauncherConnectionCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LauncherConnectionCompleteDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "currentVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastConnected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Launcher version'),
    __metadata("design:type", String)
], LauncherConnectionCompleteDTO.prototype, "currentVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Last time launcher connected to user'),
    __metadata("design:type", String)
], LauncherConnectionCompleteDTO.prototype, "lastConnected", void 0);
LauncherConnectionCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Launcher connected successfully')
], LauncherConnectionCompleteDTO);
exports.LauncherConnectionCompleteDTO = LauncherConnectionCompleteDTO;
let LauncherConnectionCloseDTO = class LauncherConnectionCloseDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LauncherConnectionCloseDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "currentVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastConnected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Launcher version'),
    __metadata("design:type", String)
], LauncherConnectionCloseDTO.prototype, "currentVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Last time launcher connected to user'),
    __metadata("design:type", String)
], LauncherConnectionCloseDTO.prototype, "lastConnected", void 0);
LauncherConnectionCloseDTO = __decorate([
    (0, decorators_1.Describe)('Launcher connection was closed')
], LauncherConnectionCloseDTO);
exports.LauncherConnectionCloseDTO = LauncherConnectionCloseDTO;
let LauncherDownloadStartDTO = class LauncherDownloadStartDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LauncherDownloadStartDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "currentVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastConnected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Launcher version'),
    __metadata("design:type", String)
], LauncherDownloadStartDTO.prototype, "currentVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Last time launcher connected to user'),
    __metadata("design:type", String)
], LauncherDownloadStartDTO.prototype, "lastConnected", void 0);
LauncherDownloadStartDTO = __decorate([
    (0, decorators_1.Describe)('Launcher began a download')
], LauncherDownloadStartDTO);
exports.LauncherDownloadStartDTO = LauncherDownloadStartDTO;
let LauncherUpdateStartDTO = class LauncherUpdateStartDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LauncherUpdateStartDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], LauncherUpdateStartDTO.prototype, "context", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Last time launcher connected to user'),
    __metadata("design:type", String)
], LauncherUpdateStartDTO.prototype, "currentVersion", void 0);
LauncherUpdateStartDTO = __decorate([
    (0, decorators_1.Describe)('Launcher started an update')
], LauncherUpdateStartDTO);
exports.LauncherUpdateStartDTO = LauncherUpdateStartDTO;
let LauncherUpdateCompleteDTO = class LauncherUpdateCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LauncherUpdateCompleteDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currentVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], LauncherUpdateCompleteDTO.prototype, "context", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Last time launcher connected to user'),
    __metadata("design:type", String)
], LauncherUpdateCompleteDTO.prototype, "currentVersion", void 0);
LauncherUpdateCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Launcher started an update')
], LauncherUpdateCompleteDTO);
exports.LauncherUpdateCompleteDTO = LauncherUpdateCompleteDTO;
let LauncherSetVersionDTO = class LauncherSetVersionDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LauncherSetVersionDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "currentVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Last time launcher connected to user'),
    __metadata("design:type", String)
], LauncherSetVersionDTO.prototype, "currentVersion", void 0);
LauncherSetVersionDTO = __decorate([
    (0, decorators_1.Describe)('Launcher version was set')
], LauncherSetVersionDTO);
exports.LauncherSetVersionDTO = LauncherSetVersionDTO;
let LauncherCheckInstalledGamesStartDTO = class LauncherCheckInstalledGamesStartDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LauncherCheckInstalledGamesStartDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "currentVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Launcher version'),
    __metadata("design:type", String)
], LauncherCheckInstalledGamesStartDTO.prototype, "currentVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Any additional context'),
    __metadata("design:type", String)
], LauncherCheckInstalledGamesStartDTO.prototype, "context", void 0);
LauncherCheckInstalledGamesStartDTO = __decorate([
    (0, decorators_1.Describe)('Launcher started check for user installed games')
], LauncherCheckInstalledGamesStartDTO);
exports.LauncherCheckInstalledGamesStartDTO = LauncherCheckInstalledGamesStartDTO;
let LauncherCheckInstalledGamesCompleteDTO = class LauncherCheckInstalledGamesCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.LauncherCheckInstalledGamesCompleteDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "currentVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Launcher version'),
    __metadata("design:type", String)
], LauncherCheckInstalledGamesCompleteDTO.prototype, "currentVersion", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Any additional context'),
    __metadata("design:type", String)
], LauncherCheckInstalledGamesCompleteDTO.prototype, "context", void 0);
LauncherCheckInstalledGamesCompleteDTO = __decorate([
    (0, decorators_1.Describe)('Launcher completed check for user installed games')
], LauncherCheckInstalledGamesCompleteDTO);
exports.LauncherCheckInstalledGamesCompleteDTO = LauncherCheckInstalledGamesCompleteDTO;
